import { GraphSchema } from '@camelot/server';
import { DocumentDto } from '@camelot/services';

import { ExecutionType } from './execution-type';
import { MandateStatus } from './mandate-status';
import { Periodicity } from './periodicity';

export interface Mandate {
  id: string;
  debtorFirstName: string;
  debtorLastName: string;
  debtorLanguage: string;
  debtorIban: string;
  creditorName: string;
  mandateNumber: string;
  status: MandateStatus;
  contactId: string;
  tenantId: string;
  companyId: string;
  executionType: ExecutionType;
  periodicity: Periodicity;
  thresholdIncents: number;
  succeededAt?: string;
  failedAt?: string;
  revokedAt?: string;
  documentId?: string;
}

export interface MandateExtended extends Mandate {
  document?: DocumentDto;
}

export interface MandateAuthorizationPayloadInput {
  contactId: string;
  successUrl: string | null;
  failureUrl: string | null;
  errorUrl: string | null;
  cancelUrl: string | null;
}

export interface MandateAuthorization {
  creationLink: string;
}

export const mandateProps = new GraphSchema<Mandate>([
  'id',
  'creditorName',
  'debtorFirstName',
  'debtorLastName',
  'debtorLanguage',
  'debtorIban',
  'mandateNumber',
  'status',
  'contactId',
  'tenantId',
  'companyId',
  'executionType',
  'periodicity',
  'thresholdIncents',
  'succeededAt',
  'failedAt',
  'revokedAt',
  'documentId',
]);
